const carouselItems = [
  {
    title: '2024娱乐圈年度盘点：最热门十大事件回顾',
    desc: '从年初的恋情曝光到年末的综艺爆款，回顾这一年娱乐圈最令人难忘的吃瓜名场面。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20annual%20entertainment%20review%20with%20warm%20coral%20and%20gold%20gradients%2C%20overlapping%20newspaper%20and%20magazine%20collage%20elements%2C%20modern%20design%20with%20geometric%20timeline%20shapes%2C%20cinematic%20atmosphere%20with%20soft%20glow&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '综艺新时代：2024最值得关注的十大综艺节目',
    desc: '从选秀到真人秀，从音乐竞演到生活观察，本年度综艺市场百花齐放，精品频出。',
    tag: '综艺专题',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20variety%20show%20spotlight%20with%20warm%20amber%20and%20peach%20palette%2C%20geometric%20stage%20design%20and%20spotlight%20elements%2C%20modern%20editorial%20composition%20with%20star%20ratings%2C%20clean%20cinematic%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '网红经济深度观察：从流量到品牌的转型之路',
    desc: '头部网红如何突破流量瓶颈？内容创作者如何实现品牌升级？深度解析行业变革。',
    tag: '深度分析',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20influencer%20economy%20and%20brand%20building%2C%20warm%20coral%20and%20gold%20tones%2C%20geometric%20growth%20charts%20and%20network%20nodes%2C%20modern%20clean%20design%20with%20flowing%20connections%2C%20professional%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '影视剧口碑榜：观众真实评分最高的十部作品',
    desc: '抛开流量数据和营销宣传，看真实观众如何评判今年的影视作品，口碑才是硬道理。',
    tag: '口碑推荐',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20film%20and%20drama%20rating%20board%2C%20warm%20golden%20and%20soft%20coral%20palette%2C%20geometric%20star%20ratings%20and%20trophy%20elements%2C%20modern%20editorial%20design%20with%20cinematic%20bars%2C%20elegant%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '音乐节季全攻略：下半年值得关注的音乐盛事',
    desc: '从阵容到场地，从票价到交通，为你整理下半年最值得参加的音乐节完整指南。',
    tag: '活动指南',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20music%20festival%20guide%20with%20warm%20amber%20and%20peach%20gradients%2C%20geometric%20stage%20and%20crowd%20silhouettes%2C%20modern%20editorial%20composition%20with%20sound%20wave%20patterns%2C%20festive%20yet%20clean%20atmosphere&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    title: '社交平台趋势报告：2024热门话题与用户行为洞察',
    desc: '微博、抖音、小红书三大平台的话题趋势分析，了解吃瓜群众的关注焦点和行为模式。',
    tag: '趋势报告',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20social%20media%20trends%20and%20user%20behavior%2C%20warm%20coral%20and%20gold%20palette%2C%20geometric%20data%20visualization%20and%20social%20icons%2C%20modern%20clean%20design%20with%20flowing%20infographic%20elements&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">焦点专题</h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              精心策划的深度专题内容，多角度解读最热门的吃瓜话题
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {carouselItems.map((item, idx) => (
              <a
                key={idx}
                href="#carousel"
                onClick={(e) => handleNavClick(e, '#carousel')}
                className="group block bg-background-50 rounded-lg overflow-hidden transition-colors hover:bg-background-200/70 cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                      if (target.parentElement) {
                        target.parentElement.style.display = 'none';
                      }
                    }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                  <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 font-medium">
                    <span>查看专题</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}